import { render, staticRenderFns } from "./MatrixView.vue?vue&type=template&id=5b6c5136&scoped=true&"
import script from "./MatrixView.vue?vue&type=script&lang=ts&"
export * from "./MatrixView.vue?vue&type=script&lang=ts&"
import style0 from "./MatrixView.vue?vue&type=style&index=0&id=5b6c5136&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6c5136",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VContainer,VIcon})
